import React, { useContext, useState } from "react";
import { Box, Text } from "grommet";
import { downloadCSV } from "../lib/exportcsv";
import { NotificationsContext } from "./NotificationsProvider";
import {
    faArrowRightFromBracket as IconExport,
    faFileCsv as IconCSV,
    faFilePdf as IconPDF
} from '@fortawesome/pro-light-svg-icons';
import FontAwesomeIcon from "./FontAwesomeIcon";
import Button from "./Button";
import DropButton from "./DropButton";

const ExportDropButton = ({
    data,
    exportConfigs,
    filename,
    isFullData,
    getFullData,
    onExportCSVClicked,
    onExportPDFClicked,
    dataName = '',
    showPDFOption = false
}) => {
    const notificationCtx = useContext(NotificationsContext);
    const [open, setOpen] = useState(false);

    const handleCSVExport = async () => {
        setOpen(false);
        if (onExportCSVClicked) {
            onExportCSVClicked();
        } else {
            const dataToDownload = !isFullData ? (await getFullData()) : data;
            dataToDownload ?
                downloadCSV(dataToDownload, exportConfigs, filename) :
                notificationCtx.showNotification({ message: 'Something went wrong. Please try exporting CSV later.', type: 'error' });
        }
    };

    const handlePDFExport = () => {
        setOpen(false);
        if (onExportPDFClicked) {
            onExportPDFClicked();
        }
    };

    // If no PDF option, render simpler button (same as original ExportButton)
    if (!showPDFOption) {
        return (
            <Box width={{ max: 'small' }} align="center" justify="center">
                <Button
                    event={{ section: `${dataName}_data_table`, element: 'export_csv' }}
                    onClick={handleCSVExport}
                    icon={<FontAwesomeIcon SelectedIcon={IconExport} size="small" />}
                    aria-label="Export CSV"
                    tip="Export CSV"
                    hoverIndicator
                />
            </Box>
        );
    }

    // Render dropdown with CSV and PDF options
    return (
        <Box width={{ max: 'small' }} align="center" justify="center">
            <DropButton
                event={{ section: `${dataName}_data_table`, element: 'export_dropdown' }}
                icon={<FontAwesomeIcon SelectedIcon={IconExport} size="small" />}
                aria-label="Export"
                tip="Export"
                hoverIndicator
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                dropAlign={{ top: 'bottom', right: 'right' }}
                dropContent={(
                    <Box background="background" round="xsmall" border overflow="hidden">
                        <Box
                            direction="row"
                            align="center"
                            gap="small"
                            pad="small"
                            hoverIndicator
                            onClick={handleCSVExport}
                            focusIndicator={false}
                        >
                            <FontAwesomeIcon SelectedIcon={IconCSV} size="small" />
                            <Text size="small">CSV</Text>
                        </Box>
                        <Box border={{ side: 'top', color: 'border' }} />
                        <Box
                            direction="row"
                            align="center"
                            gap="small"
                            pad="small"
                            hoverIndicator
                            onClick={handlePDFExport}
                            focusIndicator={false}
                        >
                            <FontAwesomeIcon SelectedIcon={IconPDF} size="small" />
                            <Text size="small">PDF</Text>
                        </Box>
                    </Box>
                )}
            />
        </Box>
    );
};

export default ExportDropButton;
